import React from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * QuestionTooltip component
 * Provides tooltips for questions in the form steps
 * 
 * @param {Object} props - Component props
 * @param {string} props.content - Tooltip content
 * @param {string} props.position - Tooltip position ('top', 'right', 'bottom', 'left')
 * @param {string} props.iconSize - Icon size ('sm', 'md', 'lg')
 * @param {string} props.iconColor - Icon color
 * @returns {JSX.Element} QuestionTooltip component
 */
const QuestionTooltip = ({
  content,
  position = 'top',
  iconSize = 'sm',
  iconColor = 'text-gray-400'
}) => {
  // Get position classes
  const getPositionClasses = () => {
    switch (position) {
      case 'right':
        return 'left-full ml-2';
      case 'bottom':
        return 'top-full mt-2';
      case 'left':
        return 'right-full mr-2';
      case 'top':
      default:
        return 'bottom-full mb-2';
    }
  };
  
  // Get icon size classes
  const getIconSizeClasses = () => {
    switch (iconSize) {
      case 'lg':
        return 'w-5 h-5';
      case 'md':
        return 'w-4 h-4';
      case 'sm':
      default:
        return 'w-3.5 h-3.5';
    }
  };
  
  return (
    <div className="group relative inline-block">
      <HelpCircle className={`${getIconSizeClasses()} ${iconColor} hover:text-gray-600 transition-colors`} />
      
      <div className={`hidden group-hover:block absolute z-10 ${getPositionClasses()} w-48 p-2 text-xs text-white bg-gray-800 rounded-md shadow-lg`}>
        {content}
        
        {/* Arrow */}
        <div className={`absolute ${
          position === 'top' ? 'bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rotate-45' :
          position === 'right' ? 'left-0 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45' :
          position === 'bottom' ? 'top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45' :
          'right-0 top-1/2 transform translate-x-1/2 -translate-y-1/2 rotate-45'
        } w-2 h-2 bg-gray-800`}></div>
      </div>
    </div>
  );
};

export default QuestionTooltip;